import React, { useMemo } from "react";
import TableWrapper from "../Table/tableWrapper";
import { generateChPerformanceTable } from "../../ChPerformanceReportHelperLib/chPerformanceDataHelper";
import styles from "./chPerformanceReport.module.css";

const TABLE_HEADERS = [
    'Name',
    '# of deliveries',
    '% On-time delivery',
    'Avg. Promise time',
    'Avg. placement to pickup',
    'Avg. drive time',
    'Avg. delivery time',
    '% Pickup within 20 min',
    '% Delivery within 40 min',
];

const ChPerformanceBreakdownTable = ({ companySummaries, accountsMap, selectedCompanyIds }) => {
    const tableArr = useMemo(
        () => generateChPerformanceTable(accountsMap ?? {}, companySummaries ?? {}, selectedCompanyIds ?? []),
        [accountsMap, companySummaries, selectedCompanyIds]
    );

    return (
        <div className={styles.breakdownWrap}>
            <span className={styles.breakdownTitle}>Breakdown by Companies</span>
            <TableWrapper
                tableHeaderArr={TABLE_HEADERS}
                tableBodyArr={tableArr}
                option={{ firstRowWidth: 20 }}
            />
        </div>
    );
};

export default ChPerformanceBreakdownTable;
